import uuid from 'uuid/v4';

export default class Item {
  constructor(itemName = 'Window 1') {
    this.itemId = uuid();
    this.label = itemName;
    this.retail = 0.0;
  }
}
